import React from "react";
import "./App.css";
import { BrowserRouter, Navigate, Route, Routes } from "react-router-dom";
import Home from "./pages/Home/Home";
import AboutUs from "./pages/AboutUs/AboutUs";
import DigitalTwin from "./pages/DigitalTwin/DigitalTwin";
import It from "./pages/It/It";
import Design from "./pages/Design/Design";
import Consulting from "./pages/Consulting";
import TrackRecord from "./pages/TrackRecord/TrackRecord";
import News from "./pages/News/News";
import "./locales/i18n";
import Layout from "./layout/Layout";
import Business from "./pages/AboutUs/Business/Business";
import Ceo from "./pages/AboutUs/Ceo/Ceo";
import Vision from "./pages/AboutUs/Vision/Vision";
import Ci from "./pages/AboutUs/Ci/Ci";
import History from "./pages/AboutUs/History/History";
import SmartGreen from "./pages/DigitalTwin/SmartGreen/SmartGreen";
import TestBed from "./pages/TestBed";
import SaaSDt from "./pages/DigitalTwin/SaaSDt/SaaSDt";
import ItDecarbonization from "./pages/It/ItDecarbonization/ItDecarbonization";
import ItCertification from "./pages/It/ItCertification/ItCertification";
import NetZeroConsulting from "./pages/It/NetZeroConsulting/NetZeroConsulting";
import DesignSolution from "./pages/Design/DesignSolution/DesignSolution";
import DesignGallery from "./pages/Design/DesignGallery/DesignGallery";
import DesignCity from "./pages/Design/DesignCity/DesignCity";
import TotalEco from "./pages/TotalEco";
import ItEnvironment from "./pages/ItEnvironment";
import Academy from "./pages/News/Academy";
import NewsRoom from "./pages/News/NewsRoom/NewsRoom";
import RepresentativePerformance from "./pages/TrackRecord/RepresentativePerformance/RepresentativePerformance ";
import MeasuringInstrument from "./pages/TrackRecord/MeasuringInstrument/MeasuringInstrument";
import TrackRecordClient from "./pages/TrackRecord/TrackRecordClient/TrackRecordClient";
import PerformanceByYear from "./pages/TrackRecord/PerformanceByYear/PerformanceByYear";
import ProjectPerformance from "./pages/TrackRecord/ProjectPerformance/ProjectPerformance";
import NewsArticle from "./pages/News/NewsRoom/NewsArticle/NewsArticle";
import ReDirect from "./hooks/ReDirect";

// const items = t("", { returnObjects: true }) as {};

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          {/* 기본 진입 → /ko */}
          <Route path="/" element={<Navigate to="/ko" replace />} />
          <Route path="/:lang" element={<Layout />}>
            <Route index element={<Home />} />

            <Route path="about" element={<AboutUs />}>
              <Route index element={<ReDirect to="about/greeting" />} />
              <Route path="greeting" element={<Business />} />
              <Route path="organization" element={<Ceo />} />
              <Route path="vision" element={<Vision />} />
              <Route path="history" element={<History />} />
              <Route path="ci" element={<Ci />} />
            </Route>

            <Route path="digital-transformation" element={<DigitalTwin />}>
              <Route index element={<ReDirect to="digital-transformation/smart-green-esg" />} />
              <Route path="smart-green-esg" element={<SmartGreen />} />
              <Route path="saas-platform" element={<SaaSDt />} />
              <Route path="testbed" element={<TestBed />} />
            </Route>

            <Route path="esg-rnd" element={<It />}>
              <Route index element={<ReDirect to="esg-rnd/decarbonization" />} />
              <Route path="decarbonization" element={<ItDecarbonization />} />
              <Route path="global-certification" element={<ItCertification />} />
              <Route path="carbon-neutral-energy" element={<NetZeroConsulting />} />
            </Route>

            <Route path="design" element={<Design />}>
              <Route index element={<ReDirect to="design/esg-design" />} />
              <Route path="esg-design" element={<DesignSolution />} />
              <Route path="smart-landscape" element={<DesignCity />} />
              <Route path="gallery" element={<DesignGallery />} />
            </Route>

            <Route path="eco-planning" element={<Consulting />}>
              <Route index element={<ReDirect to="eco-planning/eco-consulting" />} />
              <Route path="eco-consulting" element={<TotalEco />} />
              <Route path="environment-simulation" element={<ItEnvironment />} />
            </Route>

            <Route path="news" element={<News />}>
              <Route index element={<ReDirect to="news/press" />} />
              <Route path="press">
                <Route index element={<NewsRoom />} />
                <Route path=":id" element={<NewsArticle />} />
              </Route>
              <Route path="academy" element={<Academy />} />
            </Route>

            <Route path="projects" element={<TrackRecord />}>
              <Route index element={<ReDirect to="projects/residential" />} />
              <Route path="residential" element={<RepresentativePerformance />} />
              <Route path="project-list" element={<ProjectPerformance />} />
              <Route path="yearly" element={<PerformanceByYear />} />
              <Route path="clients" element={<TrackRecordClient />} />
              <Route path="equipment" element={<MeasuringInstrument />} />
            </Route>
          </Route>
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
